import { DisciplineSubType, DisciplineType } from '@/lib/types';

import { JobCategoryPage } from '@/features/job-category-page/types';
import { isPageAlliedHealth } from '@/features/job-category-page/utils/discipline-utils';
import {
  DISCIPLINE_SUB_TYPE_ENUM_TO_PARAM,
  DISCIPLINE_SUB_TYPE_PARAM_TO_ENUM,
  DISCIPLINE_TYPE_ENUM_TO_PARAM,
  DISCIPLINE_TYPE_PARAM_TO_ENUM,
  isParamDisciplineSubType,
  isParamDisciplineType,
} from '@/utils/discipline-utils';

export type JobCategoryPageRouteParams = {
  rawDisciplineType?: string;
  disciplineType?: DisciplineType;
  rawDisciplineSubType?: string;
  disciplineSubType?: DisciplineSubType;
  discipline?: string;
  specialty?: string;
  region?: string;
};

export const extractJobCategoryRouteParams = (
  slug: string[]
): JobCategoryPageRouteParams | false => {
  const DISCIPLINE_TYPE_INDEX = 0;
  const DISCIPLINE_SUB_TYPE_INDEX = 1;
  let DISCIPLINE_INDEX = null;
  let SPECIALTY_INDEX = 2;
  let STATE_INDEX = 3;

  const params: JobCategoryPageRouteParams = {};

  const disciplineType = slug[DISCIPLINE_TYPE_INDEX];
  if (disciplineType) {
    if (!isParamDisciplineType(disciplineType)) return false;
    params.disciplineType = DISCIPLINE_TYPE_PARAM_TO_ENUM[disciplineType];
    params.rawDisciplineType = disciplineType;
  }

  const disciplineSubType = slug[DISCIPLINE_SUB_TYPE_INDEX];
  if (disciplineSubType) {
    if (!isParamDisciplineSubType(disciplineSubType)) return false;
    params.disciplineSubType =
      DISCIPLINE_SUB_TYPE_PARAM_TO_ENUM[disciplineSubType];
    params.rawDisciplineSubType = disciplineSubType;
  }

  if (isPageAlliedHealth(params)) {
    DISCIPLINE_INDEX = 2;
    SPECIALTY_INDEX = 3;
    STATE_INDEX = 4;
  }

  const discipline = DISCIPLINE_INDEX && slug[DISCIPLINE_INDEX];
  if (discipline) {
    params.discipline = discipline;
  }

  const specialty = SPECIALTY_INDEX && slug[SPECIALTY_INDEX];
  if (specialty) {
    params.specialty = specialty;
  }

  const state = STATE_INDEX && slug[STATE_INDEX];
  if (state) {
    params.region = state;
  }

  return params;
};

export const buildJobCategoryPageUrl = (
  page: Partial<JobCategoryPage>
): string => {
  const { disciplineType, disciplineSubType, discipline, specialty, region } =
    page;
  const paths = ['healthcare-jobs'];

  if (disciplineType) {
    paths.push(DISCIPLINE_TYPE_ENUM_TO_PARAM[disciplineType]);
  }

  if (disciplineSubType) {
    paths.push(DISCIPLINE_SUB_TYPE_ENUM_TO_PARAM[disciplineSubType]);
  }

  if (isPageAlliedHealth(page) && discipline) {
    paths.push(discipline.slug);
  }

  if (specialty) {
    paths.push(specialty.slug);
  }

  if (region) {
    paths.push(region.slug);
  }

  return `/${paths.join('/')}`;
};
